export enum LeadCheckCode {
	HAS_SAME_EMAIL = 'HAS_SAME_EMAIL',
	HAS_TENANT_WITH_SAME_EMAIL = 'HAS_TENANT_WITH_SAME_EMAIL',
	VALID = 'VALID',
};

export const errorCodeMap = {
	0: LeadCheckCode.HAS_SAME_EMAIL,
	1: LeadCheckCode.HAS_TENANT_WITH_SAME_EMAIL,
	2: LeadCheckCode.VALID,
};

export enum TEMPLATE_EMAIL_NAME {
	LEAD_ADDED = 'LeadAddedNotification',
};
